import React, { useEffect, useState } from 'react'
import { Switcher } from 'chemistry'
import { getLocale } from 'client/common/utils'
import {
  getSelectedWithToggle,
  onSelectFilter
} from 'client/fragments/listerFragment/components/Filters/CheckListFilter'

const AVAILABILITY_FILTER_NAMES = [
  'Aankoopmogelijkheden',
  'Bezorg- en ophaalopties',
  'Possibilités d’achat',
  'facets.availability_status_facet'
]
const AVAILABILITY_FACET_NAME = 'availability_status_facet'
const inStoreFR = 'Disponible en magasin'
const inStoreNL = 'Beschikbaar in winkel'
const homeDeliveryNL = 'Thuisbezorgd'
const homeDeliveryFR = 'Livraison à domicile'

const AvailabilitySwitcher = ({ collection, filterProcessedData, format, lang, useAlgolia }) => {
  const [isSwitched, setIsSwitched] = useState(false)
  const [isSwitcherClickedOn, setIsSwitcherClickedOn] = useState(false)
  const isBricoFr = getLocale(format, lang) === 'fr_BE'

  const availabilityFilter = useAlgolia
    ? collection.find(f => f.name === AVAILABILITY_FACET_NAME)
    : collection.find(f => AVAILABILITY_FILTER_NAMES.includes(f.name))
  const inStoreAvailabilityItem = isBricoFr
    ? availabilityFilter?.items?.find(i => i.value === inStoreFR)
    : availabilityFilter?.items?.find(i => i.value === inStoreNL)
  const homeDeliveryAvailabilityItem = isBricoFr
    ? availabilityFilter?.items?.find(i => i.value === homeDeliveryFR)
    : availabilityFilter?.items?.find(i => i.value === homeDeliveryNL)

  useEffect(() => {
    if (!availabilityFilter) return

    const checkedItems = availabilityFilter.items.map(i => i.checked && i.value)

    if (
      (checkedItems.includes(inStoreNL) || checkedItems.includes(inStoreFR)) &&
      !checkedItems.includes(homeDeliveryNL) &&
      !checkedItems.includes(homeDeliveryFR)
    ) {
      setIsSwitched(true)
    } else if (
      (checkedItems.includes(inStoreNL) || checkedItems.includes(inStoreFR)) &&
      (checkedItems.includes(homeDeliveryNL) || checkedItems.includes(homeDeliveryFR)) &&
      isSwitcherClickedOn
    ) {
      setIsSwitched(true)
      // unselect Thuisbezorgd
      onSelectFilter({
        filter: { ...availabilityFilter },
        availabilityItem: { ...homeDeliveryAvailabilityItem },
        filterPosition: 'top',
        onChange: filterProcessedData.onChange,
        getSelectedWithToggleFunc: getSelectedWithToggle
      })()
    } else {
      setIsSwitched(false)
    }
  }, [availabilityFilter, collection, filterProcessedData.onChange, homeDeliveryAvailabilityItem, isSwitcherClickedOn])

  const onClickAvailabilitySwitcher = () => {
    setIsSwitcherClickedOn(!isSwitched)
    // select/unselect inStore checkbox
    onSelectFilter({
      filter: { ...availabilityFilter },
      availabilityItem: { ...inStoreAvailabilityItem },
      filterPosition: 'top',
      onChange: filterProcessedData.onChange,
      getSelectedWithToggleFunc: getSelectedWithToggle
    })()
  }

  return (
    <Switcher
      isDisabled={!inStoreAvailabilityItem}
      showTooltipOnHover={!inStoreAvailabilityItem}
      tooltipOnHoverContent={
        isBricoFr
          ? 'Ces produits sont actuellement disponibles exclusivement en ligne, avec livraison à domicile ou retrait en point colis.'
          : 'Deze artikelen zijn op dit moment alleen online te bestellen. Je kunt ze thuis of bij een afhaalpunt laten bezorgen.'
      }
      isChecked={isSwitched}
      colorScheme='yellow'
      size='lg'
      scale={1.2}
      label={isBricoFr ? inStoreFR : 'Beschikbaar in winkel'}
      onChange={onClickAvailabilitySwitcher}
      showTooltip={true}
      tooltip={{
        content: isBricoFr
          ? 'Affichez uniquement les articles disponibles en magasin. Certains peuvent également être commandés en ligne. Consultez la page produit pour voir toutes les options.'
          : 'Gebruik deze filter om alleen producten te zien die beschikbaar zijn in onze winkels. Sommige kun je ook online bestellen. Bekijk de productpagina voor alle mogelijkheden.'
      }}
    />
  )
}

export default AvailabilitySwitcher
